import {
  ClassificationNodesQuery,
  ClassificationNodesSearchSettings,
  AppSettings,
  TreeTypeEnum,
  AliasSettings,
  Customer,
  ApplicationFilters,
  Criteria,
  CategoryCriteria,
  AppSpecificSettings,
  VariantSettings,
  ClientInfo,
  AppSortSettings,
  MapSettings,
  SortDirectionEnum,
  ClassificationNodesSearchResult,
  ClassificationNode,
  ClassificationAdditionalInfo,
  ClassificationAdditionalInfoTypeEnum,
  ClassificationParentsQuery,
  ClassificationParentsSearchSettings,
  ClassificationQuery,
  ClassificationSearchSettings,
  ClassificationsSearchResult,
  ClassificationItem,
  Image,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class ClassificationsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Retrieves detailed information for specific classification nodes by their identifiers.
   */
  static nodes(
    params: {
      /** requestBody */
      body?: ClassificationNodesQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationNodesSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Nodes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Retrieves the parent classification nodes (breadcrumb path) from the specified CID up to the root.
The root node itself is not included in the result.
 */
  static parents(
    params: {
      /** requestBody */
      body?: ClassificationParentsQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationNodesSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Parents';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Retrieves the classification tree structure starting from the specified CID or from root if not provided.
This endpoint does not apply search/filter parameters and is intended for building the main category menu.
 */
  static tree(
    params: {
      /** requestBody */
      body?: ClassificationQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Tree';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
